import React from "react";
import { Drawer, IconButton, Paper } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Menu } from "../../containers/Menu";

function AttributesDrawerMobile({ open, onClose }: IAttributesDrawerMobile) {
  return (
    <Drawer
      PaperProps={{
        style: { width: "80%" },
      }}
      ModalProps={{
        style: {
          zIndex: 40000
        }
      }}
      anchor={"right"}
      open={open}
      onClose={onClose}
    >
      <div
        style={{
          width: "100%",
          justifyContent: "flex-end",
          alignItems: "center",
          display: "flex",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <Menu />
    </Drawer>
  );
}

export interface IAttributesDrawerMobile {
  open: boolean;
  onClose: () => void;
}

export default AttributesDrawerMobile;
